
import {Component, Vue} from "vue-property-decorator";
import {saatGecerliMi} from "@/services/senkronPlanGovde";
import Times from "@/components/inputs/Times.vue";

/**
 * Ön-kontrol ve sabah raporu saatleri (Faz 3, Ö-P3: PLAN BAŞINA DEĞİL genel ayar).
 *
 * Ayar localStorage'da durur; sunucuda kolonu yok ve bilerek eklenmedi — bu iki
 * bildirim istemci tarafındadır ve bilgisayar başına anlamlıdır.
 *
 * Saat girişi repodaki yerleşik `Times` bileşeniyle MASKELİ (vue-the-mask,
 * "##:##"): kullanıcı ":" karakterini elle yazmıyor.
 *
 * `Times` değeri `@change` anında emit ediyor (her tuşta değil), dolayısıyla
 * yazma doğal olarak alandan çıkışta oluyor. Değer YEREL tutulup store'a ancak
 * geçerliyse yazılır; getter/setter'lı bir computed'a bağlansaydı yarım yazılmış
 * her değer reddedilir ve getter eskisini geri yazarak yazmayı imkânsız kılardı.
 */
@Component({
  components: {Times}
})
export default class SenkronAyarKarti extends Vue {
  onKontrol = "";
  sabahRaporu = "";

  /**
   * Geçersiz giriş sonrası alanları YENİDEN KURMAK için sayaç.
   *
   * `Times` değeri kendi `localValue`sunda tutuyor ve yalnız `value` prop'u
   * DEĞİŞTİĞİNDE ondan tazeliyor. Geçersiz bir saat girildiğinde biz değeri
   * kayıtlı saate geri döndürüyoruz — ama bu, prop'un edit öncesindeki değerinin
   * TA KENDİSİ olduğu için Vue "değişmedi" deyip bildirim yapmıyor ve ekranda
   * kullanıcının yazdığı bozuk metin ("25:99") kalıyordu. `:key` değişince
   * bileşen yeniden kurulup kayıtlı değerle açılıyor.
   */
  tazelemeSayaci = 0;

  created() {
    this.storedanOku();
  }

  private storedanOku() {
    this.onKontrol = this.$store.getters["senkronAyarlari/onKontrolSaati"];
    this.sabahRaporu = this.$store.getters["senkronAyarlari/sabahRaporuSaati"];
  }

  /** Geçersiz girişi ekrandan da temizler (bkz. `tazelemeSayaci`). */
  private geriAl() {
    this.storedanOku();
    this.tazelemeSayaci += 1;
  }

  saatKurali(deger: string): boolean | string {
    return saatGecerliMi(deger) || "Saat SS:DD biçiminde olmalıdır.";
  }

  onKontrolYaz(deger: string | null) {
    this.onKontrol = deger ?? "";
    if (!saatGecerliMi(this.onKontrol)) {
      // Geçersiz değerle ayrılındıysa kayıtlı saate geri dön: yarım bir metin
      // ekranda kalıp "ayarım bu" izlenimi vermemeli.
      this.geriAl();
      return;
    }
    if (this.onKontrol === this.$store.getters["senkronAyarlari/onKontrolSaati"]) return;

    this.$store.commit("senkronAyarlari/SET_ON_KONTROL_SAATI", this.onKontrol);
    this.$emit("saatler-degisti");
    this.$toast.success("Gece öncesi kontrol saati " + this.onKontrol + " olarak kaydedildi.");
  }

  sabahRaporuYaz(deger: string | null) {
    this.sabahRaporu = deger ?? "";
    if (!saatGecerliMi(this.sabahRaporu)) {
      this.geriAl();
      return;
    }
    if (this.sabahRaporu === this.$store.getters["senkronAyarlari/sabahRaporuSaati"]) return;

    this.$store.commit("senkronAyarlari/SET_SABAH_RAPORU_SAATI", this.sabahRaporu);
    this.$emit("saatler-degisti");
    this.$toast.success("Sabah raporu saati " + this.sabahRaporu + " olarak kaydedildi.");
  }
}
